'use client';

import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { SettingRadioGroup } from '@/app/components/shared/SettingRadioGroup';
import { cn } from '@/app/utils';

type ToolSettingsRadioGroupProps = ComponentPropsWithoutRef<typeof SettingRadioGroup> & {
  itemSize?: 'default' | 'tall';
};

const ACTIVE_OPTION_CLASSNAME = 'border-[#5765f2] bg-[rgba(87,101,242,0.20)]';

const OPTIONS_WRAPPER_CLASSNAME_MAP = {
  default: 'rounded-8 hover:bg-system-white08',
  tall: 'h-auto rounded-8 hover:bg-system-white08',
} as const;

const LABEL_CLASSNAME_MAP = {
  default: undefined,
  tall: 'py-4',
} as const;

export const ToolSettingsRadioGroup = forwardRef<HTMLDivElement, ToolSettingsRadioGroupProps>(
  ({ itemSize = 'tall', className, optionsWrapperClassName, activeOptionClassName, labelClassName, ...props }, ref) => {
    return (
      <SettingRadioGroup
        ref={ref}
        className={cn('rounded-8 bg-system-white04', className)}
        optionsWrapperClassName={cn(OPTIONS_WRAPPER_CLASSNAME_MAP[itemSize], optionsWrapperClassName)}
        activeOptionClassName={cn(ACTIVE_OPTION_CLASSNAME, activeOptionClassName)}
        labelClassName={cn(LABEL_CLASSNAME_MAP[itemSize], labelClassName)}
        {...props}
      />
    );
  },
);

ToolSettingsRadioGroup.displayName = 'ToolSettingsRadioGroup';
